import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userRoleData } from 'redux_store/slices/userRole';

const PlatformProtectedRoute = () => {
  const location = useLocation();
  const role = useSelector(userRoleData);
  const userRole = role?.userRole;

  if (!userRole) {
    return <Navigate to="/platform/login" state={{ from: location }} replace />;
  }

  // Only superAdmin (platform admin) can access /platform/* routes
  if (userRole !== 'superAdmin') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default PlatformProtectedRoute;
